export default "__VITE_ASSET__DciFi2I6__"